import React from "react";

/**
 * Official Sereno logo:
 * - Mauve circle (#A762B1)
 * - Cream sprout leaves (#FFF7E9)
 * - Gold coin (light top #FDD98C, dark edge #E59D32)
 *
 * Props:
 *   - size: number (pixels), default 44
 *   - className: optional wrapper classes
 */
export const SerenoLogo = ({ size = 44, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Logo Sereno"
      className={className}
      data-testid="sereno-logo"
    >
      {/* Mauve circle background */}
      <circle cx="50" cy="50" r="50" fill="#A762B1" />

      {/* Sprout stem */}
      <rect x="48.5" y="38" width="3" height="28" rx="1.5" fill="#FFF7E9" />

      {/* Left leaf */}
      <path
        d="M50 42 C 38 40, 30 32, 32 22 C 42 22, 50 30, 50 42 Z"
        fill="#FFF7E9"
      />

      {/* Right leaf */}
      <path
        d="M50 44 C 62 42, 70 34, 68 24 C 58 24, 50 32, 50 44 Z"
        fill="#FFF7E9"
      />

      {/* Gold coin — dark edge (back) */}
      <ellipse cx="50" cy="72" rx="18" ry="7" fill="#E59D32" />

      {/* Gold coin — light top (front) */}
      <ellipse cx="50" cy="69" rx="18" ry="7" fill="#FDD98C" />

      {/* Inner ring on the coin */}
      <ellipse
        cx="50"
        cy="69"
        rx="12"
        ry="4.5"
        fill="none"
        stroke="#E59D32"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default SerenoLogo;
